import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ settings: null });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const reload = () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  useEffect(() => {
    reload();
  }, []);
  return <SiteContext.Provider value={{ settings, reload }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export function universeFromPath(pathname) {
  if (pathname.startsWith("/ong")) return "ong";
  if (pathname.startsWith("/association")) return "association";
  return "common";
}
